module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-R-31.6a82a7ec.png";